import { useEffect, useState } from "react";
import * as S from "./datePickerModal.style";
import dayjs from "dayjs";

type DatePickerModalType = {
  isOpen: boolean;
  onClose: () => void;
  currentDate: dayjs.Dayjs;
  onDateSelect: (date: dayjs.Dayjs) => void;
};

const DatePickerModal = ({
  isOpen,
  onClose,
  currentDate,
  onDateSelect,
}: DatePickerModalType) => {
  /** ============================= state 영역 ============================= */
  const [selectedYear, setSelectedYear] = useState(currentDate.year());
  const [selectedMonth, setSelectedMonth] = useState(currentDate.month() + 1);
  /** ============================= API 영역 ============================= */

  /** ============================= 비즈니스 로직 영역 ============================= */
  const currentYear = dayjs().year();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - 5 + i);
  const months = Array.from({ length: 12 }, (_, i) => i + 1);

  const handleConfirm = () => {
    const newDate = dayjs()
      .year(selectedYear)
      .month(selectedMonth - 1);
    onDateSelect(newDate);
    onClose();
  };

  const handleCancel = () => {
    setSelectedYear(currentDate.year());
    setSelectedMonth(currentDate.month() + 1);
    onClose();
  };

  /** ============================= 컴포넌트 영역 ============================= */

  /** ============================= useEffect 영역 ============================= */

  /** 날짜 변경시 날짜 모달 셀렉트박스의 상태값도 변경 */
  useEffect(() => {
    setSelectedYear(currentDate.year());
    setSelectedMonth(currentDate.month() + 1);
  }, [currentDate]);

  if (!isOpen) return null;
  return (
    <S.ModalOverlay onClick={onClose}>
      <S.ModalContent onClick={(e) => e.stopPropagation()}>
        <S.ModalHeader>
          <h3>날짜 선택</h3>
        </S.ModalHeader>

        <S.ModalBody>
          <S.SelectContainer>
            <S.SelectLabel>년도</S.SelectLabel>
            <S.Select
              value={selectedYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
            >
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}년
                </option>
              ))}
            </S.Select>
          </S.SelectContainer>

          <S.SelectContainer>
            <S.SelectLabel>월</S.SelectLabel>
            <S.Select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(Number(e.target.value))}
            >
              {months.map((month) => (
                <option key={month} value={month}>
                  {month}월
                </option>
              ))}
            </S.Select>
          </S.SelectContainer>
        </S.ModalBody>

        <S.ModalFooter>
          <S.Button onClick={handleCancel}>취소</S.Button>
          <S.Button onClick={handleConfirm} primary>
            확인
          </S.Button>
        </S.ModalFooter>
      </S.ModalContent>
    </S.ModalOverlay>
  );
};

export default DatePickerModal;
